// Read from the displayed Firestore document (latest or selected history).
export function buildBaselineParams(fsData) {
  const text = (value) => String(value ?? '').trim();
  const rawFactory = text(fsData?.FACTORY_CODE ?? fsData?.FACTORY);
  return {
    plant_id: text(fsData?.PLANT_ID),
    factory_code: /^0+$/.test(rawFactory) ? '0' : rawFactory,
    line: text(fsData?.LINE).replace(/\s+/g, '').toUpperCase(),
    material_description: text(fsData?.MATERIAL_DESCRIPTION ?? fsData?.SKU),
  };
}
